import { AsyncPipe } from '@angular/common';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, HostListener, inject, input, Input } from '@angular/core';
import { HighchartsChartComponent } from 'highcharts-angular';
import * as Highmaps from 'highcharts/highmaps';

import iconLibrary from 'src/app/common/iconLibrary';
import { CountryChartOptionsPipe } from './country-chart-options.pipe';
import { TableToCountryPipe } from './table-to-country.pipe';
import { GenericChart } from 'src/openapi-client';
import { CountryTable } from 'src/openapi-client';
import { AtomicBlueprintSupported } from '../../shared/atomic/atomic.component';

@Component({
  selector: 'wct-country-chart',
  standalone: true,
  imports: [
    TableToCountryPipe,
    CountryChartOptionsPipe,
    HighchartsChartComponent
  ],
  templateUrl: './country-chart.component.html',
  styleUrl: './country-chart.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CountryChartComponent implements AtomicBlueprintSupported<CountryTable> {
  data = input.required<CountryTable>();
  chartInstance: Highcharts.Chart | undefined;
  
  @HostListener('window:resize')
  onResize() {
    this.chartInstance?.reflow();
  }

  protected readonly iconLibrary = iconLibrary; 

  protected async zoomIn(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.chartInstance?.mapZoom(0.8); 
  }

  protected async zoomOut(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.chartInstance?.mapZoom(1.25);
  }
}
